import { MomentInput } from "moment";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { DEFAULT_DATE_FORMAT, utc } from "PFCore/helpers/date";
import { useGetColor } from "PFCore/hooks/use_get_color";

type MisalignmentHeaderProps = {
  start: string;
  end: string;
};

export const MisalignmentHeader = ({ start, end }: MisalignmentHeaderProps) => {
  const getColor = useGetColor();
  const isOneDay = start === end;
  const formatDate = (date: MomentInput) => utc(date).format(DEFAULT_DATE_FORMAT);

  return (
    <>
      <Icon name="calendar-delete" fill={getColor("paletteOrange3")} />
      <Typography variant="labelBold">
        {isOneDay ? formatDate(start) : `${formatDate(start)} - ${formatDate(end)}`}
      </Typography>
    </>
  );
};
